import { GpsLogItem } from './gps-log-item.model';

export class GpsLogDeviceGroup {
    deviceId: string;
    items: GpsLogItem[] = [];
    truckNumber: string;

    constructor(item: GpsLogItem) {
        this.deviceId = item.deviceId;
        this.items.push(item);
        this.truckNumber = item.truckNumber;
    }
}
